import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Box,
  Button,
  Container,
  Heading,
  VStack,
  Text,
  Card,
  CardBody,
  Spinner,
} from '@chakra-ui/react';

function Login() {
  const navigate = useNavigate();
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/app');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: '/app'
      }
    });
  };

  if (isLoading) {
    return (
      <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" color="purple.500" thickness="4px" />
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center">
      <Container maxW="md">
        <VStack spacing={8}>
          {/* Logo/Header */}
          <VStack spacing={2}>
            <Heading
              size="xl"
              bgGradient="linear(to-r, brand.darkPurple, brand.purple)"
              bgClip="text"
            >
              Radiancebook EMR
            </Heading>
            <Text color="gray.600">Sign in to your account</Text>
          </VStack>

          {/* Login Card */}
          <Card w="full" boxShadow="lg">
            <CardBody p={8}>
                <VStack spacing={5}>
                <Text color="gray.600" textAlign="center">
                  Secure authentication powered by Auth0
                </Text>

                  <Button
                    colorScheme="purple"
                    size="lg"
                    width="full"
                  onClick={handleLogin}
                  >
                  Sign In with Auth0
                  </Button>

                  <Box
                    w="full"
                    p={4}
                    bg="blue.50"
                    borderRadius="md"
                    borderWidth="1px"
                    borderColor="blue.200"
                  >
                    <Text fontSize="sm" color="blue.800" fontWeight="medium" mb={1}>
                    Multi-Tenant Access:
                    </Text>
                    <Text fontSize="sm" color="blue.700">
                    You will be redirected to your organization's login page.
                    </Text>
                  </Box>
                </VStack>
            </CardBody>
          </Card>

          {/* Back to home */}
          <Button
            variant="ghost"
            colorScheme="purple"
            onClick={() => navigate('/')}
          >
            ← Back to Home
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}

export default Login;
